import React, { useState } from 'react';
import { SVGS, PNGS } from '../../assets';
import { OrderLevelScheme, SchemeIconType } from '@zonofi/zono-money-store';
import '../cart-details/cart-details-content.scss';

const SCHEME_ICON_MAP: Record<SchemeIconType, string> = {
  FREE: SVGS.SchemeFreeIcon,
  PERCENT: PNGS.SchemePercentIcon,
  PRODUCTS: SVGS.NoProductIcon,
  DIVISION: PNGS.SchemeDivisionIcon,
};

const getSchemeIcon = (scheme: OrderLevelScheme): string => {
  if (scheme.schemeIconType && SCHEME_ICON_MAP[scheme.schemeIconType]) {
    return SCHEME_ICON_MAP[scheme.schemeIconType];
  }
  return PNGS.ManualOfferIcon;
};

interface PromotionsModalProps {
  schemes: OrderLevelScheme[];
  onApply: (scheme: OrderLevelScheme) => void;
  onSkip: () => void;
  onCancel: () => void;
  isApplying?: boolean;
  modalTitle?: string;
  selectedBenefit?: OrderLevelScheme;
}

export const PromotionsModal: React.FC<PromotionsModalProps> = ({
  schemes,
  onApply,
  onSkip,
  onCancel,
  isApplying,
  modalTitle,
  selectedBenefit,
}) => {
  const [selectedSchemeId, setSelectedSchemeId] = useState<number | null>(null);

  const handleApply = () => {
    const selected = schemes.find((s) => s.id === selectedSchemeId);
    if (selected) {
      onApply(selected);
    }
  };

  return (
    <div className="promotions-modal-overlay" onClick={onCancel}>
      <div className="promotions-modal" onClick={(e) => e.stopPropagation()}>
        <div className="promotions-modal-header">
          <div className="promotions-modal-handle" />
          <div className="promotions-modal-header-row">
            <div style={{ width: 30 }} />
            <span className="promotions-modal-header-title font-semibold">
              {modalTitle || 'Promotions'}
            </span>
            <span
              className="promotions-modal-header-cancel font-semibold"
              onClick={onCancel}
            >
              Cancel
            </span>
            {/* <span
              className="promotions-modal-header-skip font-semibold"
              onClick={onSkip}
            >
              Skip & Checkout
            </span> */}
          </div>
        </div>

        <div className="promotions-modal-body">
          <div className="promotions-modal-list">
            {schemes.map((scheme) => {
              const isSelected =
                selectedSchemeId === scheme.id ||
                selectedBenefit?.id === scheme.id;
              return (
                <div
                  key={scheme.id}
                  className={`promotions-modal-card ${
                    isSelected ? 'promotions-modal-card--selected' : ''
                  }`}
                  onClick={() => setSelectedSchemeId(scheme.id)}
                >
                  <img
                    src={getSchemeIcon(scheme)}
                    alt=""
                    className="promotions-modal-card-icon"
                  />
                  <div className="promotions-modal-card-content">
                    <p className="promotions-modal-card-name">
                      <span className="font-semibold">{scheme.name}</span>
                      {scheme.description && (
                        <span className="font-regular">
                          {' '}
                          {scheme.description}
                        </span>
                      )}
                    </p>
                    <span className="promotions-modal-card-meta font-regular">
                      {scheme.code}
                      {scheme.minOrderQuantity
                        ? ` • Min Order Quantity: ${scheme.minOrderQuantity}`
                        : ''}
                    </span>
                  </div>
                  <div
                    className={`promotions-modal-radio ${
                      isSelected ? 'promotions-modal-radio--selected' : ''
                    }`}
                  >
                    {isSelected && (
                      <div className="promotions-modal-radio-dot" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <button
            className="promotions-modal-apply font-semibold"
            onClick={handleApply}
            disabled={selectedSchemeId === null || isApplying}
          >
            {isApplying ? 'Applying...' : 'Apply Benefit'}
          </button>
        </div>
      </div>
    </div>
  );
};
